

<router-outlet >
 <block-ui >
  </block-ui>

  <p-toast></p-toast>
</router-outlet>
